"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MARKET_MAP = void 0;
const MARKET_MAP = {
    'market1': 'HK',
    'market2': 'MF',
    'market3': 'PF',
    'market4': 'BD',
    'market5': 'US',
    'market6': 'FX',
    'market7': 'SH',
    'market8': 'SZ',
    'market9': 'CN',
    'market10': 'SG',
    'market11': 'JP',
    'market12': 'DE',
    'market13': 'CC',
    'market14': 'TW',
    'market15': 'MY',
    'market16': 'FR',
    'market17': 'NL',
    'market18': 'PT',
    'market19': 'BE',
    'market20': 'GB',
    'market21': 'IT',
    'market22': 'CA',
    'market23': 'AU',
    'market24': 'KR',
    'market25': 'BJ',
    'market26': 'IN',
    'market27': 'SN',
    'market28': 'CFD',
    'market29': 'EC',
    'market30': 'IP',
};
exports.MARKET_MAP = MARKET_MAP;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uZi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImNvbmYudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsTUFBTSxVQUFVLEdBQUc7SUFDZixTQUFTLEVBQUUsSUFBSTtJQUNmLFNBQVMsRUFBRSxJQUFJO0lBQ2YsU0FBUyxFQUFFLElBQUk7SUFDZixTQUFTLEVBQUUsSUFBSTtJQUNmLFNBQVMsRUFBRSxJQUFJO0lBQ2YsU0FBUyxFQUFFLElBQUk7SUFDZixTQUFTLEVBQUUsSUFBSTtJQUNmLFNBQVMsRUFBRSxJQUFJO0lBQ2YsU0FBUyxFQUFFLElBQUk7SUFDZixVQUFVLEVBQUUsSUFBSTtJQUNoQixVQUFVLEVBQUUsSUFBSTtJQUNoQixVQUFVLEVBQUUsSUFBSTtJQUNoQixVQUFVLEVBQUUsSUFBSTtJQUNoQixVQUFVLEVBQUUsSUFBSTtJQUNoQixVQUFVLEVBQUUsSUFBSTtJQUNoQixVQUFVLEVBQUUsSUFBSTtJQUNoQixVQUFVLEVBQUUsSUFBSTtJQUNoQixVQUFVLEVBQUUsSUFBSTtJQUNoQixVQUFVLEVBQUUsSUFBSTtJQUNoQixVQUFVLEVBQUUsSUFBSTtJQUNoQixVQUFVLEVBQUUsSUFBSTtJQUNoQixVQUFVLEVBQUUsSUFBSTtJQUNoQixVQUFVLEVBQUUsSUFBSTtJQUNoQixVQUFVLEVBQUUsSUFBSTtJQUNoQixVQUFVLEVBQUUsSUFBSTtJQUNoQixVQUFVLEVBQUUsSUFBSTtJQUNoQixVQUFVLEVBQUUsSUFBSTtJQUNoQixVQUFVLEVBQUUsS0FBSztJQUNqQixVQUFVLEVBQUUsSUFBSTtJQUNoQixVQUFVLEVBQUUsSUFBSTtDQUNuQixDQUFDO0FBR0UsZ0NBQVUifQ==